module.exports = "https://www.gc-qa.gnp.com.mx/6414f7e867fa21fbce0a59cc17b4bc6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/camera1.svg
// module id = 8068
// module chunks = 0